import * as React from "react"
import { Typography } from "@mui/material"

export default function displayNameColumn() {
    return {
        name: "displayName",
        label: "Display Name",
        options: {
            filter: false,
            sort: true,
            setCellHeaderProps: () => ({ style: { textAlign: "left" } }),
            setCellProps: () => ({ style: { textAlign: "left" } }),
            customBodyRender: (value) => (
                <Typography color={value ? "text.primary" : "text.disabled"}>
                    {value || "—"}
                </Typography>
            )
        }
    }
}
